var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#9146FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2093 20.5409L26.4951 24.2552H22.7808L19.5308 27.5052V24.2552H15.3522V10.3266H30.2093V20.5409Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4236 8.46946L9.7807 13.1123V29.8266H15.3521V34.4695L19.995 29.8266H23.7093L32.0664 21.4695V8.46946H14.4236ZM30.2093 20.5409L26.495 24.2552H22.7807L19.5307 27.5052V24.2552H15.3521V10.3266H30.2093V20.5409Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4235 13.5766H25.5664V19.148H27.4235V13.5766Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3163 13.5766H20.4592V19.148H22.3163V13.5766Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/Twitch.d4ff4961b676c460f3a845dd0588b5e3.svg";
export { ForwardRef as ReactComponent };